/**
 * Coup de pouce — Attendu 1096 « multiplication comme addition itérée :
 * 3 + 3 + 3 + 3 = 4 × 3 » (automatisme 4e, l. 637). UNE page en QUATRE
 * TEMPS, partagée par les trois generator_keys.
 *
 * L'image que l'élève a déjà : les paquets du cycle 3 (CM1, « 4 paquets de
 * 3 »). Un seul exemple, sacrifié : l'exemple du programme, 4 fois 3. À
 * chaque temps un paquet de 3 se pose et la somme s'allonge d'un « + 3 » ;
 * au dernier temps, le résultat en gros « 3 + 3 + 3 + 3 = 4 × 3 » et une
 * ligne en langue d'élève : « 4 paquets de 3, c'est 4 fois 3. » Rien à
 * calculer : la valeur 12 n'est pas écrite (c'est 1093).
 *
 * SACRIFIÉ : 4 termes de 3 et 3 termes de 4, 4 × 3 et 3 × 4 (gen_1096,
 * SACRIFIE, auto-testé par gen1096.self.test.js).
 * Largeur bornée à 340 px, tailles de 1048, texte dans la figure.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';

/** Quatre paquets de 3 ronds, côte à côte. */
const X0 = 46;
const PAS = 82;
const Y = 60;
const paquet = (k) => {
    const x = X0 + k * PAS;
    return `<rect x="${x}" y="${Y}" width="64" height="44" rx="8" fill="${ORANGE_CLAIR}" stroke="${ORANGE}" stroke-width="2"/>
    <circle cx="${x + 14}" cy="${Y + 22}" r="7" fill="${ORANGE}"/>
    <circle cx="${x + 32}" cy="${Y + 22}" r="7" fill="${ORANGE}"/>
    <circle cx="${x + 50}" cy="${Y + 22}" r="7" fill="${ORANGE}"/>
    <text x="${x + 32}" y="${Y + 62}" font-size="12" font-weight="bold" text-anchor="middle" fill="${ORANGE}">3</text>`;
};

/** Un temps par paquet : le paquet et la somme qui s'allonge. */
const TEMPS = [0, 1, 2, 3].map((k) => `<g data-etape="${k + 1}">
    ${paquet(k)}
    ${k > 0 ? `<text x="${X0 + k * PAS - 12}" y="${Y + 27}" font-size="14" font-weight="bold" text-anchor="middle" fill="${ENCRE}">+</text>` : ''}
  </g>`).join('\n  ');

const SVG_PAQUETS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 222" width="100%" style="max-width:340px;height:auto;display:block" role="img" data-etapes="4"
     aria-label="Quatre paquets de 3 ronds orange se posent l'un après l'autre, avec un plus entre les paquets. Au dernier temps, en gros : 3 plus 3 plus 3 plus 3 égale 4 fois 3. 4 paquets de 3, c'est 4 fois 3.">
  ${TEMPS}

  <!-- temps 4 : l'écriture en produit et le geste -->
  <g data-etape="4">
    <text x="200" y="160" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${ORANGE}">3 + 3 + 3 + 3</tspan> = <tspan fill="${BLEU}">4</tspan> × <tspan fill="${ORANGE}">3</tspan></text>
    <text x="200" y="196" font-size="13" text-anchor="middle" fill="${ENCRE}"><tspan font-weight="bold" fill="${BLEU}">4</tspan> paquets de <tspan font-weight="bold" fill="${ORANGE}">3</tspan>, c'est <tspan font-weight="bold" fill="${BLEU}">4</tspan> fois <tspan font-weight="bold" fill="${ORANGE}">3</tspan>.</text>
  </g>
</svg>`.trim();

const AIDE = { pages: [{ titre: '4 paquets de 3', svg: SVG_PAQUETS }] };

const CP_1096 = {
    flash_texte_trou_saisie: AIDE,
    ecriture_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1096;
